import React, { Component } from 'react';
import logo from './img/dirad_logo.png';

export default class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			errorBg: 0,
			loginConfig: [
				{
					data: "email",
					type: "text",
					label: "Email Address",
					error: ""
				},
				{
					data: "password",
					type: "password",
					label: "Password",
					error: ""
				}
			],
			loginCreds: {},
		}
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.login()
		}
	}

	fieldChange = (e) => {
		var newCreds = this.state.loginCreds
		newCreds[e.currentTarget.getAttribute('data-value')] = e.currentTarget.value
		this.setState({ loginCreds: newCreds })
	}

	login = (e) => {
		this.setState({ loading: true });
		this.props.saveCreds(this.state.loginCreds)
		window.setTimeout(function () {
			this.props.ws.send(JSON.stringify({ route: 'login', loginCreds: this.state.loginCreds }))
		}.bind(this), 200)
	}

	loginWithMicrosoft = (e) => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'loginWithMicrosoft' }))
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.setState({ loading: false, errorBg: 1 });
		}
		setTimeout(function () {
			this.setState({ errorBg: 0 });
		}.bind(this), 1000)
	}

	render() {
		var loginComps = []

		for (var comp of this.state.loginConfig) {
			loginComps.push(
				<div className="snazzyInputBox" key={comp.data}>
					<div className="error">{comp.error}</div>
					<input className="textInput" type={comp.type} required value={this.state.loginCreds[comp.data] ? this.state.loginCreds[comp.data] : ''} data-value={comp.data} onChange={this.fieldChange} ></input>
					<span className="inputBar"></span>
					<label className="textLabel">{comp.label}</label>
				</div>
			)
		}

		return (
			<div className="App ">
				<div className="backdrop"></div>

				<div className="loginBox" onKeyUp={this.checkEnter}>
					<img src={logo} className="App-logo" alt="logo" />

					{loginComps}

					<div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
						{this.props.loginError ? <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.props.loginError}</div> : ''}
						{this.state.loading ?
							<div className="loader"></div>

							:
							<div>
								<div>
									<div className="button" onClick={this.login}>Log In</div>
								</div>
								<div style={{ height: '40px', position: 'relative' }}>
									<div style={{ width: '100%', backgroundColor: '#BBB', height: '2px', top: '20px', position: 'absolute' }}></div>
									<div style={{ width: '40px', backgroundColor: '#fff', position: 'absolute', transform: 'translateX(-50%)', top: '10px', left: '50%' }}>
										or
									</div>
								</div>
								<div style={{ position: 'relative', padding: '1px' }}>
									<div className="button" onClick={this.loginWithMicrosoft}>
										<img style={{ position: 'absolute', left: '15px', top: '14px' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAjUlEQVRYR2P8FKD0n4EMwPSPkYFn011GkNbaPQz/mf6RYQgDAwPjqANGQ2A0BEZDYDQERkNgwEPgm58cWbUh8z9GBvYtD8G1YTUltSF5lSj1dIF9MJCAkWHZZ7KigIGBhYEhihPsgf87Gcg0g4GBkWHJezI1szAwxPCOOmA0BEZDYDQERkNgNASGfggAAK5b0SCaHk4zAAAAAElFTkSuQmCC"></img>
										<div style={{ position: 'relative', left: '10px' }}>Sign in with Microsoft</div>
									</div>
								</div>
							</div>
						}

						{false?<div style={{padding: '15px'}}>Forgot Password?</div> : ''}
					</div>
				</div >
			</div >
		)
	}
}
